import { __awaiter, __generator } from "tslib";
import { routeAsync } from './routeAsync';
export function routeLazy(load) {
    var _this = this;
    var router;
    return routeAsync(function (request, response) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!router) return [3 /*break*/, 2];
                    return [4 /*yield*/, load()];
                case 1:
                    router = (_a.sent()).default;
                    _a.label = 2;
                case 2: return [2 /*return*/, router(request, response)];
            }
        });
    }); });
}
